module.exports = __webpack_public_path__ + "img/logo-off.59b0e9be.png";